module.exports = {"id":"dp3_2l3q6","text":"Integrating and re-elaborating digital content","instructions":"How should digital technologies be used when enhancing existing content?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"3.2","questionType":"PickOne","random":true,"options":[{"id":"dp3_2l3q6-a1","text":"Selectively and with ethical consideration","score":3.7},{"id":"dp3_2l3q6-a2","text":"Automatically and without review","score":1.3},{"id":"dp3_2l3q6-a3","text":"Only when required by system limits","score":1.3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat3.2/l3q6.json
// module id = 1140
// module chunks = 41